export default "/images/43dbb9d798e6ee92f9061eb56bf5cf26.jpg";